import { createSelector } from "@reduxjs/toolkit"
import { useSelector } from "react-redux"

export const selectElectricity = (state) => state.state.electricity
export const selectElectricityFiltered = (state) => state.state.electricityFiltered
export const selectAccountings = (state) => state.state.accountings
export const selectConclusions = (state) => state.state.conclusions
export const selectUser = (state) => state.state.user
// export const selectAccountingsFiltered = (state) => state.state.accountingsFiltered
export const selectRules = (state) => state.state.rules

export const selectDialFilter = (state) => state.state.filter.dial
export const selectStatementsFilter = (state) => state.state.filter.statements
export const selectChecklistFilter = (state) => state.state.filter.checklist

export const selectTransformers = createSelector(
    [selectElectricity],
    (electricitiy) => electricitiy.transformers || []
)

export const selectTransformersFiltered = createSelector(
    [selectElectricityFiltered],
    (electricitiy) => electricitiy.transformers || []
)

export const selectPillars = createSelector(
    [selectElectricity],
    (electricitiy) => electricitiy.pillars || []
)

//Опоры с примененными фильтрами (тп, дата, стадия)
export const selectPillarsFiltered = createSelector(
    [selectElectricityFiltered],
    (electricitiy) => electricitiy.pillars || []
)

const statusMap = {
    'Не устранено': 'accounting_not_completed',
    'Частично устранено': 'accounting_half_completed',
    'Устранено частично': 'accounting_half_completed',
    'Отклонено': 'accounting_rejected',
    'Готово к проверке': 'accounting_ready',
    'Устранено': 'accounting_completed',
    'Согласовано': 'accounting_approved'
}

const statementsFilterSet = createSelector(
    [selectStatementsFilter],
    (statementsFilter) => statementsFilter ? new Set(statementsFilter) : null
)
const checklistFilterSet = createSelector(
    [selectChecklistFilter],
    (checklistFilter) => checklistFilter ? new Set(checklistFilter) : null
)


const dialStatuses = {
    'rejected': 'accounting_rejected',
    'ready': 'accounting_ready',
    'success': 'accounting_completed'
}

// pillars - отфильтрованные опоры
// accountings - предписания
// dialFilter, statementsFilter, checklistFilter - фильтры статусов(предписаний)
// Выполняет привязку предписаний к опорам
// Применяем фильтры статусов(если предписание не подпадает под нужный)
// НАЗВАЧЕНИЕ: РЕНДЕР ОПОР С ПРЕДПИСАНИЯМИ НА КАРТЕ
export const selectPillarsWithAccountingsFiltered = createSelector(
    [selectPillarsFiltered, selectAccountings, selectDialFilter, statementsFilterSet, checklistFilterSet],
    (pillars, accountings, dialFilter, statementsFilter, checklistFilter) => {
        const start = new Date().getTime()
        const processedPillars = [];

        for (const pillar of pillars) {
            let accounting = pillar.accounting ? accountings[pillar.accounting] : null
            let status = pillar.status === 'default' ? pillar.status : (accounting ? (accounting.instructions === 'Согласовано' ? statusMap[accounting.instructions] : statusMap[accounting.status]) : null)
            let opacity = 2;

            // if (statementsFilter && !statementsFilter.has(pillar.fid)) {
            //     processedPillars.push({ ...pillar, opacity: 0, status: 'default', accounting: null });
            //     continue;
            // }

            //Если предписание не содержит выбранный чеклист, то скрываем предписание опопры и ставим статус по умолчанию (не отображаем)
            if (checklistFilter && !(accounting && accounting.checklist?.find(c => checklistFilter.has(c)))) {
                processedPillars.push({ ...pillar, opacity: 0, status: 'default', accounting: null });
                continue;
            }

            //Если статус предписания не подпадает под выбранный стуатус диала, то скрываем предписание опопры и ставим статус по умолчанию
            //Также определяем прозрачность текста
            if (dialFilter) {
                const dialLabels = dialFilter.labels[dialFilter.selectedLabel]
                //Если выбран не "Все", то удаляем категории из предписания, которые не подпадают под выбранный статус диала
                if (accounting?.part_elimin_categ && dialFilter.selectedLabel !== 0) {
                    const toDeleteFromCateg = Object.entries(accounting.part_elimin_categ).filter(c => Array.isArray(c[1]) && c[1].length > 0 && !dialLabels.includes(dialStatuses[c[0]])).map(c => c[1]).flat()
                    if (toDeleteFromCateg.length > 0 && accounting.checklist) {
                        accounting = { ...accounting, checklist: accounting.checklist.filter(c => !toDeleteFromCateg.includes(c)) }
                    }
                    if (checklistFilter && !(accounting && accounting.checklist?.find(c => checklistFilter.has(c)))) {
                        processedPillars.push({ ...pillar, opacity: 0, status: 'default', accounting: null });
                        continue;
                    }
                }

                // let status = pillar.accounting ? statusMap[accountings[pillar.accounting].status] : (pillar.status || 'default');
                //Если статус не найден в выбранном диале, то скрываем предписание и текст
                if (!dialLabels.includes(status)) {
                    processedPillars.push({ ...pillar, opacity: 0, status: 'default', accounting: null });
                    continue;
                }

                //Находим наименьшее opacity среди всех типов диала куда входит статус предписания кроме "Все"
                for (let i = 1; i < dialFilter.labels.length; i++) {
                    const l = dialFilter.labels[i];
                    if (l.includes(status) && dialFilter.labelsOpacity[i] < opacity) {
                        opacity = dialFilter.labelsOpacity[i];
                    }
                }
                //Если 0 то скрываем предписание, а opacity ставим из выбранного типа диала
                if (opacity === 0) {
                    processedPillars.push({ ...pillar, opacity: dialFilter.labelsOpacity[dialFilter.selectedLabel], status: 'default', accounting: null });
                    continue;
                }
                //Если выбран диал "Все" и его opacity = 0, то скрываем надпись
                if (dialFilter.selectedLabel === 0 && dialFilter.labelsOpacity[0] === 0) {
                    opacity = 0;
                }
                processedPillars.push({ ...pillar, opacity, status, accounting });
            } else {
                processedPillars.push({ ...pillar, opacity, status, accounting });
            }
            // return {
            //     ...p,
            //     accounting: p.accounting ? accountings[p.accounting] : null,
            //     status: p.status === 'default' ? p.status : statusMap[accountings[p.accounting].status]
            // }
        }
        const end = new Date().getTime()
        console.log('selectPillarsWithAccountingsFiltered', (end - start) / 1000)
        return processedPillars
    }
)



// export const selectPillarsOpacityFilter = createSelector(
//     [selectPillarsFiltered, selectDialFilter, selectStatementsFilter, selectChecklistFilter],
//     (pillars, filters) => {

//     }
// )

//Мапы основных обхектов, применяются для быстрого достпа к обхекто
export const selectMappedElectricity = createSelector(
    [selectElectricity],
    (electricity) => ({
        pillars: new Map(electricity.pillars?.map((p) => [p.fid, p])),
        fiders: new Map(electricity.fiders?.map((p) => [p.id, p])),
        transformers: new Map(electricity.transformers?.map((p) => [p.fid, p])),
        feedingSubstations: new Map(electricity.feedingSubstations?.map((p) => [p.fid, p])),
    })
)


//Мапы основных обхектов, применяются для быстрого достпа к обхекто
export const selectMappedElectricityFiltered = createSelector(
    [selectElectricityFiltered],
    (electricity) => ({
        pillars: new Map(electricity.pillars?.map((p) => [p.fid, p])),
        fiders: new Map(electricity.fiders?.map((p) => [p.id, p])),
        transformers: new Map(electricity.transformers?.map((p) => [p.fid, p])),
        feedingSubstations: new Map(electricity.feedingSubstations?.map((p) => [p.fid, p]))
    })
)

//Коллекции основных элементов, нужны для фильтрации связанных данных (например задачи)
// export const selectlectricityFilteredSet = createSelector(
//     [selectElectricityFiltered],
//     (electricity) => ({
//         pillars: new Set(electricity.pillars?.map((p) => p.fid)),
//         fiders: new Set(electricity.fiders?.map(p => p.id))
//     })
// )

export const selectAccountingsFiltered = createSelector(
    [selectAccountings, selectPillarsFiltered],
    (accountings, pillars) => {
        const pillarsIds = pillars.filter(p => p.accountings?.length > 0 && p.stage === '4').map(p => p.fid)
        return Object.values(accountings).filter(v => pillarsIds.includes(v.pillarId))
    }

)

export const selectAccountingsFilteredActive = createSelector(
    [selectAccountings, selectPillarsFiltered],
    (accountings, pillars) => {
        const pillarsIds = pillars.filter(p => p.accounting && p.stage === '4').map(p => p.fid)
        return Object.values(accountings).filter(v => pillarsIds.includes(v.pillarId))
    }

)

// Фабрика селекторов для получения предписаний по ID опоры
// export const makeSelectAccountingsByPillarId = () => createSelector(
//     [selectAccountings, (state, pillarId) => pillarId],
//     (accountings, pillarId) => {
//         return Object.values(accountings).filter(v => v.pillarId === pillarId)
//     }
// )

// Использование: const selectAccountingsByPillarId = makeSelectAccountingsByPillarId()
// const accountings = useSelector(state => selectAccountingsByPillarId(state, pillarId))

// селекторов для получения предписаний по ID опоры
export const selectAccountingsByPillarId = createSelector(
    [selectAccountings, (state, pillarId) => pillarId],
    (accountings, pillarId) => {
        return Object.values(accountings).filter(v => v.pillarId === pillarId)
    }
)

export const selectAccountingsFilteredCounts = createSelector(
    [selectAccountingsFiltered],
    (accountings) => {
        const half_completed = accountings.filter(acc => acc.status === 'Частично устранено').length
        const not_completed = accountings.filter(acc => acc.status === 'Не устранено').length
        const actual = half_completed + not_completed
        const ready = accountings.filter(acc => acc.status === 'Готово к проверке').length
        const rejected = accountings.filter(acc => acc.status === 'Отклонено').length
        const completed = accountings.filter(acc => acc.status === 'Устранено').length
        const all = rejected + ready + actual + completed
        return {
            actual,
            half_completed,
            not_completed,
            ready,
            rejected,
            completed,
            all
        }
    }
)

//Предписания с присвоением объектов из ID
export const selectAccountingsWithFilledObjects = createSelector(
    [selectAccountingsFiltered, selectMappedElectricityFiltered],
    (accountings, electricity) => {
        return accountings.map(acc => ({
            ...acc,
            pillar: electricity.pillars.get(acc.pillarId),
            tp: electricity.transformers.get(acc.tpId),
            ps: electricity.feedingSubstations.get(acc.psId)
        }))
    }
)





//Сгруппированные по населенным пунетам предаисания
//Применение диала и чеклиста
export const selectAccountingsGroupedByTowns = createSelector(
    [selectAccountingsFiltered, selectPillarsWithAccountingsFiltered, selectMappedElectricityFiltered, selectDialFilter, checklistFilterSet],
    (accountings, pillars, electricity, dialFilter, checklistFilter) => {
        const start = new Date().getTime()
        const towns = [...new Set(accountings.map(p => p.town))]
        const res = towns.map(town => {
            const tp = [...new Set(accountings.filter(p => p.town === town).map(p => Number(p.tpId)))]
            const tps = tp.map(t => {
                let _pillars = accountings.filter(p => p.tpId === t).map(acc => {
                    const pillar = pillars.find(p => p.fid === acc.pillarId)
                    return {
                        ...pillar,
                        accounting: acc,
                        status: statusMap[acc.status]
                    }
                })
                if (dialFilter) {
                    _pillars = _pillars.map(pillar => {
                        let status = pillar.status
                        let accounting = pillar.accounting
                        let opacity = 2

                        const dialLabels = dialFilter.labels[dialFilter.selectedLabel]
                        //Если выбран не "Все", то удаляем категории из предписания, которые не подпадают под выбранный статус диала
                        if (accounting?.part_elimin_categ && dialFilter.selectedLabel !== 0) {
                            const toDeleteFromCateg = Object.entries(accounting.part_elimin_categ).filter(c => Array.isArray(c[1]) && c[1].length > 0 && !dialLabels.includes(dialStatuses[c[0]])).map(c => c[1]).flat()
                            if (toDeleteFromCateg.length > 0 && accounting.checklist) {
                                accounting = { ...accounting, checklist: accounting.checklist.filter(c => !toDeleteFromCateg.includes(c)) }
                            }
                            // if (checklistFilter && !(accounting && accounting.checklist?.find(c => checklistFilter.has(c)))) {
                            //     return null
                            // }
                        }


                        dialFilter.labels.map((l, i) => {
                            if (i !== 0 && l.includes(status) && dialFilter.labelsOpacity[i] < opacity) opacity = dialFilter.labelsOpacity[i]
                        })
                        if (opacity === 0) return null
                        if (!dialFilter.labels[dialFilter.selectedLabel].includes(status)) return null
                        if (status === 'default') return null
                        return {
                            ...pillar,
                            opacity,
                            accounting
                        }
                    }).filter(f => f)
                }
                if (checklistFilter) {
                    _pillars = _pillars.filter(pillar => pillar.accounting.checklist && pillar.accounting.checklist.find(c => checklistFilter.has(c)))
                }


                return {
                    tp: electricity.transformers.get(t),
                    pillars: _pillars,
                    count: _pillars.length

                }
            })
            const ps = electricity.feedingSubstations.get(String(tps[0].tp.ps_id))
            return {
                town,
                tps,
                ps,
                count: tps.reduce((t, r) => t + r.count, 0)
            }
        })
        const end = new Date().getTime()
        console.log('selectAccountingsGroupedByTowns', (end - start) / 1000)
        return res
    }
)

//Сгруппированные по населенным пунетам предаисания
//Применение только диала
export const selectAccountingsGroupedByTownsNoChecklist = createSelector(
    [selectAccountingsFiltered, selectPillarsWithAccountingsFiltered, selectMappedElectricityFiltered, selectDialFilter, checklistFilterSet],
    (accountings, pillars, electricity, dialFilter, checklistFilter) => {
        const start = new Date().getTime()
        const towns = [...new Set(accountings.map(p => p.town))]
        const res = towns.map(town => {
            const tp = [...new Set(accountings.filter(p => p.town === town).map(p => Number(p.tpId)))]
            const tps = tp.map(t => {
                let _pillars = accountings.filter(p => p.tpId === t).map(acc => {
                    const pillar = pillars.find(p => p.fid === acc.pillarId)
                    return {
                        ...pillar,
                        accounting: acc,
                        status: statusMap[acc.status]
                    }
                })
                if (dialFilter) {
                    _pillars = _pillars.map(pillar => {
                        let status = pillar.status
                        let accounting = pillar.accounting
                        let opacity = 2

                        const dialLabels = dialFilter.labels[dialFilter.selectedLabel]
                        //Если выбран не "Все", то удаляем категории из предписания, которые не подпадают под выбранный статус диала
                        if (accounting?.part_elimin_categ && dialFilter.selectedLabel !== 0) {
                            const toDeleteFromCateg = Object.entries(accounting.part_elimin_categ).filter(c => Array.isArray(c[1]) && c[1].length > 0 && !dialLabels.includes(dialStatuses[c[0]])).map(c => c[1]).flat()
                            if (toDeleteFromCateg.length > 0 && accounting.checklist) {
                                accounting = { ...accounting, checklist: accounting.checklist.filter(c => !toDeleteFromCateg.includes(c)) }
                            }
                            // if (checklistFilter && !(accounting && accounting.checklist?.find(c => checklistFilter.has(c)))) {
                            //     return null
                            // }
                        }


                        dialFilter.labels.map((l, i) => {
                            if (i !== 0 && l.includes(status) && dialFilter.labelsOpacity[i] < opacity) opacity = dialFilter.labelsOpacity[i]
                        })
                        if (opacity === 0) return null
                        if (!dialFilter.labels[dialFilter.selectedLabel].includes(status)) return null
                        if (status === 'default') return null
                        return {
                            ...pillar,
                            opacity,
                            accounting
                        }
                    }).filter(f => f)
                }
                // if (checklistFilter) {
                //     _pillars = _pillars.filter(pillar => pillar.accounting.checklist && pillar.accounting.checklist.find(c => checklistFilter.has(c)))
                // }


                return {
                    tp: electricity.transformers.get(t),
                    pillars: _pillars,
                    count: _pillars.length

                }
            })
            const ps = electricity.feedingSubstations.get(String(tps[0].tp.ps_id))
            return {
                town,
                tps,
                ps,
                count: tps.reduce((t, r) => t + r.count, 0)
            }
        })
        const end = new Date().getTime()
        console.log('selectAccountingsGroupedByTowns', (end - start) / 1000)
        return res
    }
)

//Сгруппированные по КТП
export const selectAccountingsGroupedByKtp = createSelector(
    [selectAccountingsFiltered, selectPillarsWithAccountingsFiltered, selectMappedElectricityFiltered],
    (accountings, pillars, electricity) => {
        const ktp = [...new Set(accountings.map(p => Number(p.tpId)))]
        return ktp.map(t => {
            const tp = electricity.transformers.get(t)
            const ps = electricity.feedingSubstations.get(String(tp.ps_id))
            const _pillars = accountings.filter(p => p.tpId === t).map(acc => {
                const pillar = pillars.find(p => p.fid === acc.pillarId)
                return {
                    ...pillar,
                    accounting: acc,
                    status: statusMap[acc.status]
                }
            })
            return {
                tp,
                ps,
                pillars: _pillars
            }
        })

    }
)

export const selectRulesMap = createSelector(
    [selectRules],
    (rules) => {
        if (!rules) return {};
        return rules.flatMap(r => r.rules).reduce((t, r) => {
            t[r.code] = r;
            return t;
        }, {});
    }
)





export const selectAccountingsJoinPillars = createSelector(
    [selectAccountings, selectPillars],
    (accountings, pillars) => {
        return Object.values(accountings).map(acc => {
            const pillar = pillars.find(p => p.fid === acc.pillarId)
            if (!pillar || acc.instructions === 'Согласовано') return null
            return {
                ...pillar,
                accounting: acc,
                status: statusMap[acc.status]
            }
        }).filter(f => f)
    }
)

export const selectAccountingsJoinPillarsFiltered = createSelector(
    [selectAccountings, selectPillarsFiltered],
    (accountings, pillars) => {
        return Object.values(accountings).map(acc => {
            const pillar = pillars.find(p => p.fid === acc.pillarId)
            if (!pillar || acc.instructions === 'Согласовано') return null
            return {
                ...pillar,
                accounting: acc,
                status: statusMap[acc.status]
            }
        }).filter(f => f)
    }
)



export const selectAccountingsApplyDial = createSelector(
    [selectAccountingsJoinPillarsFiltered, selectDialFilter],
    (pillars, dialFilter) => {
        if (!dialFilter) return pillars

        return pillars.map(pillar => {
            let status = pillar.status
            let accounting = pillar.accounting
            let opacity = 2

            const dialLabels = dialFilter.labels[dialFilter.selectedLabel]
            //Если выбран не "Все", то удаляем категории из предписания, которые не подпадают под выбранный статус диала
            if (accounting?.part_elimin_categ && dialFilter.selectedLabel !== 0) {
                const toDeleteFromCateg = Object.entries(accounting.part_elimin_categ).filter(c => Array.isArray(c[1]) && c[1].length > 0 && !dialLabels.includes(dialStatuses[c[0]])).map(c => c[1]).flat()
                if (toDeleteFromCateg.length > 0 && accounting.checklist) {
                    accounting = { ...accounting, checklist: accounting.checklist.filter(c => !toDeleteFromCateg.includes(c)) }
                }
                // if (checklistFilter && !(accounting && accounting.checklist?.find(c => checklistFilter.has(c)))) {
                //     return null
                // }
            }
            dialFilter.labels.map((l, i) => {
                if (i !== 0 && l.includes(status) && dialFilter.labelsOpacity[i] < opacity) opacity = dialFilter.labelsOpacity[i]
            })
            if (opacity === 0) return null
            if (!dialFilter.labels[dialFilter.selectedLabel].includes(status)) return null
            if (status === 'default') return null
            return {
                ...pillar,
                accounting
            }
        }).filter(f => f)
    }
)

export const selectAccountingsApplyChecklist = createSelector(
    [selectAccountingsApplyDial, selectChecklistFilter],
    (pillars, checklistFilter) => {
        if (!checklistFilter) return pillars
        return pillars.filter(pillar => pillar.accounting?.checklist && pillar.accounting?.checklist?.find(c => checklistFilter.includes(c)))
    }
)



export const selectAccountingsFilteredCountsNew = createSelector(
    [selectAccountingsApplyChecklist],
    (accountings) => {
        const half_completed = accountings.filter(acc => acc.status === 'accounting_half_completed').length
        const not_completed = accountings.filter(acc => acc.status === 'accounting_not_completed').length
        const actual = half_completed + not_completed
        const ready = accountings.filter(acc => acc.status === 'accounting_ready').length
        const rejected = accountings.filter(acc => acc.status === 'accounting_rejected').length
        const completed = accountings.filter(acc => acc.status === 'accounting_completed').length
        const all = rejected + ready + actual + completed
        return {
            actual,
            half_completed,
            not_completed,
            ready,
            rejected,
            completed,
            all
        }
    }
)

export const selectAccountingsGroupedByTownsNew = createSelector(
    [selectAccountingsApplyChecklist, selectMappedElectricityFiltered],
    (pillars, electricity) => {
        console.log(pillars)
        const start = new Date().getTime()
        const towns = [...new Set(pillars.map(p => p.accounting.town))]
        const res = towns.map(town => {
            const tp = [...new Set(pillars.filter(p => p.accounting.town === town).map(p => Number(p.accounting.tpId)))]
            const tps = tp.map(t => {
                let _pillars = pillars.filter(p => p.accounting.town === town && p.accounting.tpId === t)
                return {
                    tp: electricity.transformers.get(t),
                    pillars: _pillars,
                    count: _pillars.length

                }
            })
            const ps = electricity.feedingSubstations.get(String(tps[0]?.tp?.ps_id))
            return {
                town,
                tps,
                ps,
                count: tps.reduce((t, r) => t + r.count, 0)
            }
        })
        const end = new Date().getTime()
        console.log('selectAccountingsGroupedByTowns', (end - start) / 1000)
        return res
    }
)


export const selectAccountingsGroupedByKtpNew = createSelector(
    [selectAccountingsJoinPillarsFiltered, selectMappedElectricityFiltered],
    (pillars, electricity) => {
        const ktp = [...new Set(pillars.map(p => Number(p.tp_id)))]
   
        return ktp.map(t => {
            const tp = electricity.transformers.get(t)
            const ps = electricity.feedingSubstations.get(String(tp.ps_id))
            const _pillars = pillars.filter(p => Number(p.tp_id) === t)
            return {
                tp,
                ps,
                pillars: _pillars
            }
        })

    }
)

export const selectAccountingsGroupedByKtpNewWithoutAnyFilters = createSelector(
    [selectAccountingsJoinPillars, selectElectricity],
    (pillars, electricity) => {
        const ktp = [...new Set(pillars.map(p => Number(p.tp_id)))]
        return ktp.map(t => {
            const tp = electricity.transformers.find(tr => tr.fid === t)
            const ps = electricity.feedingSubstations.find(fs => fs.fid === tp.ps_id)
            const _pillars = pillars.filter(p => Number(p.tp_id) === t)
            return {
                tp,
                ps,
                pillars: _pillars
            }
        })

    }
)


export const selectConclusionsForUser = createSelector(
    [selectConclusions, selectUser],
    (conclusions, user) => {
        if (!conclusions || !user) return []
        if (user.roles?.some(r => ['admin', 'project_manager'].includes(r))) return conclusions
        return conclusions.map(c => {
            const tbl = c?.tbl?.filter(t => t.responsible?.includes(user.vio_id)) || []
            if (tbl?.length === 0) return null
            return {
                ...c,
                tbl
            }
        }).filter(f => f)
    }
)